<template>
  <v-sheet class="w-100 d-flex flex-column ga-4 pr-8 pl-8">
    <FilterComponent
      v-if="hasData || rows"
      v-model:view="mode"
      v-model:filters="filters"
      v-model:search="search"
      :available-ids="availableIdsByCategory"
      :show-chart="hasData ? true : false"
      :show-table="hasData ? true : false"
      :show-search="false" 
      :show-filter="true"
      :show-refresh="false" 
      :enableProcessoSeletivo="false"
      :enableProcesso="true"
      :enableModalidade="true"
      :enableNivelEnsino="true"
      :enableCurso="false"
      :enableOfertaCurso="false"
      :enableEtapa="false"
      :enableFaixaConversao="false"
      :show-download="mode === 'table' && hasData && rows && rows.length"
      :download-disabled="!rows || !rows.length"
      @click:download="openDownloadCsvPopup"
      @click:chart="mode = 'chart'"
      @click:table="mode = 'table'"
      @update:filters="loadData($event)"
    />
    <RbLoader v-if="isLoading" v-model="rows" :contained="true" />
    <v-sheet class="d-flex justify-between ga-16" v-if="mode == 'chart' && hasData">
      <v-card class="rounded-lg overflow-hidden pa-0" :width="'90%'" elevation="0" :style="{border: '1px solid #C5C7C6'}">
        <v-sheet
          class="d-flex align-center ga-3 pa-8"
          :style="{
            background: perfUI.headerBg,
            borderBottom: '1px solid var(--v-theme-surface-variant)',
            height: '143px',
          }"
        >
          <div class="elevation-0">
            <svg  v-if="perfState==='good'"  xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
              <path d="M22.3506 35.6646L37.6256 20.3896L34.5923 17.3563L22.3506 29.5979L16.1756 23.4229L13.1423 26.4563L22.3506 35.6646ZM25.3839 47.3646C22.3867 47.3646 19.5701 46.7958 16.934 45.6583C14.2978 44.5208 12.0048 42.9771 10.0548 41.0271C8.10478 39.0771 6.56104 36.784 5.42354 34.1479C4.28604 31.5118 3.71729 28.6951 3.71729 25.6979C3.71729 22.7007 4.28604 19.884 5.42354 17.2479C6.56104 14.6118 8.10478 12.3188 10.0548 10.3688C12.0048 8.41875 14.2978 6.875 16.934 5.7375C19.5701 4.6 22.3867 4.03125 25.3839 4.03125C28.3812 4.03125 31.1978 4.6 33.834 5.7375C36.4701 6.875 38.7631 8.41875 40.7131 10.3688C42.6631 12.3188 44.2069 14.6118 45.3444 17.2479C46.4819 19.884 47.0506 22.7007 47.0506 25.6979C47.0506 28.6951 46.4819 31.5118 45.3444 34.1479C44.2069 36.784 42.6631 39.0771 40.7131 41.0271C38.7631 42.9771 36.4701 44.5208 33.834 45.6583C31.1978 46.7958 28.3812 47.3646 25.3839 47.3646ZM25.3839 43.0312C30.2228 43.0312 34.3214 41.3521 37.6798 37.9938C41.0381 34.6354 42.7173 30.5368 42.7173 25.6979C42.7173 20.859 41.0381 16.7604 37.6798 13.4021C34.3214 10.0438 30.2228 8.36458 25.3839 8.36458C20.5451 8.36458 16.4465 10.0438 13.0881 13.4021C9.72978 16.7604 8.05062 20.859 8.05062 25.6979C8.05062 30.5368 9.72978 34.6354 13.0881 37.9938C16.4465 41.3521 20.5451 43.0312 25.3839 43.0312Z" fill="#006030"/>
            </svg>

            <svg v-else-if="perfState==='moderate'" xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
              <path d="M25.0207 36.8018C25.6346 36.8018 26.1491 36.5941 26.5644 36.1788C26.9797 35.7636 27.1873 35.249 27.1873 34.6351C27.1873 34.0212 26.9797 33.5066 26.5644 33.0913C26.1491 32.6761 25.6346 32.4684 25.0207 32.4684C24.4068 32.4684 23.8922 32.6761 23.4769 33.0913C23.0616 33.5066 22.854 34.0212 22.854 34.6351C22.854 35.249 23.0616 35.7636 23.4769 36.1788C23.8922 36.5941 24.4068 36.8018 25.0207 36.8018ZM22.854 28.1351H27.1873V15.1351H22.854V28.1351ZM25.0207 47.6351C22.0234 47.6351 19.2068 47.0663 16.5707 45.9288C13.9346 44.7913 11.6415 43.2476 9.6915 41.2976C7.7415 39.3476 6.19775 37.0545 5.06025 34.4184C3.92275 31.7823 3.354 28.9656 3.354 25.9684C3.354 22.9712 3.92275 20.1545 5.06025 17.5184C6.19775 14.8823 7.7415 12.5893 9.6915 10.6393C11.6415 8.68926 13.9346 7.14551 16.5707 6.00801C19.2068 4.87051 22.0234 4.30176 25.0207 4.30176C28.0179 4.30176 30.8346 4.87051 33.4707 6.00801C36.1068 7.14551 38.3998 8.68926 40.3498 10.6393C42.2998 12.5893 43.8436 14.8823 44.9811 17.5184C46.1186 20.1545 46.6873 22.9712 46.6873 25.9684C46.6873 28.9656 46.1186 31.7823 44.9811 34.4184C43.8436 37.0545 42.2998 39.3476 40.3498 41.2976C38.3998 43.2476 36.1068 44.7913 33.4707 45.9288C30.8346 47.0663 28.0179 47.6351 25.0207 47.6351ZM25.0207 43.3018C29.8596 43.3018 33.9582 41.6226 37.3165 38.2643C40.6748 34.9059 42.354 30.8073 42.354 25.9684C42.354 21.1295 40.6748 17.0309 37.3165 13.6726C33.9582 10.3143 29.8596 8.63509 25.0207 8.63509C20.1818 8.63509 16.0832 10.3143 12.7248 13.6726C9.3665 17.0309 7.68734 21.1295 7.68734 25.9684C7.68734 30.8073 9.3665 34.9059 12.7248 38.2643C16.0832 41.6226 20.1818 43.3018 25.0207 43.3018Z" fill="#DE3730"/>
            </svg>

            <svg v-else xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
              <path d="M2.1665 45.4997L25.9998 4.33301L49.8332 45.4997H2.1665ZM9.6415 41.1663H42.3582L25.9998 12.9997L9.6415 41.1663ZM25.9998 38.9997C26.6137 38.9997 27.1283 38.792 27.5436 38.3768C27.9589 37.9615 28.1665 37.4469 28.1665 36.833C28.1665 36.2191 27.9589 35.7045 27.5436 35.2893C27.1283 34.874 26.6137 34.6663 25.9998 34.6663C25.3859 34.6663 24.8714 34.874 24.4561 35.2893C24.0408 35.7045 23.8332 36.2191 23.8332 36.833C23.8332 37.4469 24.0408 37.9615 24.4561 38.3768C24.8714 38.792 25.3859 38.9997 25.9998 38.9997ZM23.8332 32.4997H28.1665V21.6663H23.8332V32.4997Z" fill="#93000A"/>
            </svg>
          </div>

          <div class="d-flex flex-column ">
            <span class="text-start title-card" :style="{ color: perfUI.titleColor }">
              {{ perfUI.title }}
            </span>
            <span class="text-start subtitle-card" v-html="perfSubtitle"></span>
          </div>
        </v-sheet>

        <v-row no-gutters>
          <v-col cols="12" sm="6" md="3" class="pa-4 cell cell--left bg-critical">
            <div class="text-title-subcard mb-1 text-start">Faixa crítica</div>
            <div class="insight-percent-text text-start" :style="{ color: perfUI.criticalColor }">
              {{ overviewCounts.lt60 }}
            </div>
            <div class="text-start">{{ overviewCounts.lt60_total }} matrículas</div>
          </v-col>

          <v-col cols="12" sm="6" md="3" class="pa-4 cell">
            <div class="text-title-subcard mb-1 text-start">Média baixa (60%-70%)</div>
            <div class="insight-percent-text text-start">{{ overviewCounts.between60_70 }}</div>
            <div class="text-start">{{ overviewCounts.between60_70_total }} matrículas</div>
          </v-col>

          <v-col cols="12" sm="6" md="3" class="pa-4 cell">
            <div class="text-title-subcard mb-1 text-start">Média alta (70%-90%)</div>
            <div class="insight-percent-text text-start">{{ overviewCounts.between70_90 }}</div>
            <div class="text-start">{{ overviewCounts.between70_90_total }} matrículas</div>
          </v-col>

          <v-col cols="12" sm="6" md="3" class="pa-4 cell cell--right bg-trust">
            <div class="text-title-subcard mb-1 text-start">Alta confiança (&gt; 90%)</div>
            <div class="insight-percent-text text-start" :style="{ color: perfUI.trustColor }">
              {{ overviewCounts.gt90 }}
            </div>
            <div class="text-start">{{ overviewCounts.gt90_total }} matrículas</div>
          </v-col>
        </v-row>
      </v-card>
      <div class="d-flex justify-center">
        <div ref="accuracyEl" style="width:244px;height:283px;"></div>
      </div>
    </v-sheet>

    <v-sheet class="d-flex ga-16" :width="'100%'"  v-if="mode == 'table' && hasData">
      <TableInsights
        :headers="tableHeaders"
        :items="rows"
        :show-total="true"
        total-title="Total geral/Média geral"
        :total-col-span="3"
        :totals="tableTotals"
        v-model:page="page"
        v-model:itemsPerPage="ipp"
        :items-per-page-options="[5,10,25,50]"
        :highlight-index="1"
        :summary-items="[
          { key: 'conversions', label: 'Conversões' },
          { key: 'lt60', label: 'Menor de 60%' },
          { key: 'between60_70', label: 'Entre 60% e 70%' },
          { key: 'between70_90', label: 'Entre 70% e 90%' },
          { key: 'gt90', label: 'Maior que 90%' }
        ]"
        summary-emphasis="conversions"
        tooltip-description="Distribuição das inscrições ativas nos últimos 3 meses entre as faixas de confiança, indicando o volume de matrículas estimadas conforme o potencial de fechamento de cada grupo."
        @row:click="handleRowClick($event)"
      >
        <template #cell:lt60="{ value }">
          <div class="d-flex align-center justify-end ga-1">
            <span>{{ value }}</span>

            <v-tooltip
              v-if="pctToNumber(value) > 15"
              location="top"
              max-width="360"
            >
              <template #activator="{ props }">
                <v-icon
                  v-bind="props"
                  size="16"
                  color="#FF8A00"
                >
                  mdi-alert-circle
                </v-icon>
              </template>

              Baixa performance detectada. Revise as configurações do relatório.
            </v-tooltip>

          </div>
        </template>

        <template #total:lt60="{ value }">{{ value }}</template>
        <template #total:between60_70="{ value }">{{ value }}</template>
        <template #total:between70_90="{ value }">{{ value }}</template>
        <template #total:gt90="{ value }">{{ value }}</template>
      </TableInsights>
    </v-sheet>

    <v-sheet class="d-flex ga-16"  v-if="!isLoading && !hasData">
      <v-card class="rounded-lg overflow-hidden pa-0" :width="'90%'" elevation="0" :style="{border: '1px solid #C5C7C6'}">
        <v-sheet
            class="d-flex align-center ga-3 pa-8"
            :style="{
              background: perfUI.headerBg,
              borderBottom: '1px solid var(--v-theme-surface-variant)',
              height: '143px',
            }"
        >
          <v-avatar class="elevation-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 52 52" fill="none">
              <path d="M25.0207 36.8018C25.6346 36.8018 26.1491 36.5941 26.5644 36.1788C26.9797 35.7636 27.1873 35.249 27.1873 34.6351C27.1873 34.0212 26.9797 33.5066 26.5644 33.0913C26.1491 32.6761 25.6346 32.4684 25.0207 32.4684C24.4068 32.4684 23.8922 32.6761 23.4769 33.0913C23.0616 33.5066 22.854 34.0212 22.854 34.6351C22.854 35.249 23.0616 35.7636 23.4769 36.1788C23.8922 36.5941 24.4068 36.8018 25.0207 36.8018ZM22.854 28.1351H27.1873V15.1351H22.854V28.1351ZM25.0207 47.6351C22.0234 47.6351 19.2068 47.0663 16.5707 45.9288C13.9346 44.7913 11.6415 43.2476 9.6915 41.2976C7.7415 39.3476 6.19775 37.0545 5.06025 34.4184C3.92275 31.7823 3.354 28.9656 3.354 25.9684C3.354 22.9712 3.92275 20.1545 5.06025 17.5184C6.19775 14.8823 7.7415 12.5893 9.6915 10.6393C11.6415 8.68926 13.9346 7.14551 16.5707 6.00801C19.2068 4.87051 22.0234 4.30176 25.0207 4.30176C28.0179 4.30176 30.8346 4.87051 33.4707 6.00801C36.1068 7.14551 38.3998 8.68926 40.3498 10.6393C42.2998 12.5893 43.8436 14.8823 44.9811 17.5184C46.1186 20.1545 46.6873 22.9712 46.6873 25.9684C46.6873 28.9656 46.1186 31.7823 44.9811 34.4184C43.8436 37.0545 42.2998 39.3476 40.3498 41.2976C38.3998 43.2476 36.1068 44.7913 33.4707 45.9288C30.8346 47.0663 28.0179 47.6351 25.0207 47.6351ZM25.0207 43.3018C29.8596 43.3018 33.9582 41.6226 37.3165 38.2643C40.6748 34.9059 42.354 30.8073 42.354 25.9684C42.354 21.1295 40.6748 17.0309 37.3165 13.6726C33.9582 10.3143 29.8596 8.63509 25.0207 8.63509C20.1818 8.63509 16.0832 10.3143 12.7248 13.6726C9.3665 17.0309 7.68734 21.1295 7.68734 25.9684C7.68734 30.8073 9.3665 34.9059 12.7248 38.2643C16.0832 41.6226 20.1818 43.3018 25.0207 43.3018Z" fill="#41546D"/>
            </svg>
          </v-avatar>
          <div class="d-flex flex-column ">
            <span class="text-start title-card-empty">
              Dados insuficientes
            </span>
            <span class="text-body-2 text-medium-emphasis">Nenhum registro entrou na(s) etapa(s) de conversão nos últimos 3 meses. <a href="https://rubeus.me/fmOxBbo" class="link-learn-more">Saiba mais.</a></span>
          </div>
        </v-sheet>
      </v-card>
    </v-sheet>

    <DetailPopUp
      v-model="detailPopUpVisible"
      :payload="payloadDetails"
      :url="urlDetailPopUp"
      :title-pop-up="detailPopUpTitle"
      subtitle-pop-up="Encontre o contato para realizar análises qualitativas"
      :headers="[
            { title:'Probabilidade', key:'probabilidade', align:'start' },
            { title:'Nome', key:'nome' },
            { title:'Nivel de ensino', key:'nome_nivelensino' },
            { title:'Unidade', key:'nome_unidade' },
            { title:'Modalidade', key:'nome_modalidade' },
          ]"
      :rows-keys="['id', 'probabilidade', 'nome', 'nome_nivelensino', 'nome_unidade', 'nome_modalidade']"
      @after-leave="detailPopUpVisible=false"
    />

    <RbPopUp
      v-model="downloadCsvPopupVisible"
      :width="400"
      confirm-text="Download"
      cancel-text="Cancelar"
      confirm-color="primary-60"
      variant-confirm="elevated"
      variant-cancel="outlined"
      :disabled-confirm="!rows || !rows.length"
      @confirm="downloadTableCsv"
    >
      <template #title>Download do relatório (CSV)</template>

      <template #message>
        Realize o download em CSV do widget<br />
        "<strong>Métricas gerais de conversão</strong>".
      </template>

      <template #confirm-icon>
        <v-icon size="18">mdi-download</v-icon>
      </template>
    </RbPopUp>

  </v-sheet>
</template>

<script>
import RbLoader from "@/ai_studio/components/common/RbLoader.vue";
import FilterComponent from './FilterComponent.vue';
import TableInsights from './TableInsights.vue';
import DetailPopUp from "./detailsPopUp/DetailPopUp.vue";
import { PostWithJson } from '@/ai_studio/http/http.js';
import { downloadCsv } from '@/ai_studio/utils/exportCsv';
import RbPopUp from '@/ai_studio/components/common/RBPopup.vue';
import { calculateAvailableIds } from '@/ai_studio/utils/entityHelper';
import * as echarts from 'echarts';

export default {
  name: 'PerformanceOverview',
  components: { 
    RbLoader,
    FilterComponent,
    TableInsights,
    DetailPopUp,
    RbPopUp
  },
  props: {
    data: { type: Object, default: () => ({}) },
  },
  data () {
    return {
      mode: 'chart',
      mockType: 'good',
      reportData: {},
      accuracy: 0,
      chart: null,
      onResize: null,
      filters: {},
      isLoading: false,
      originalAvailableIds: null,
      overviewCounts: {
        total: 198,
        lt60: '1,00%',
        between60_70: '3,00%',
        between70_90: '89,00%',
        gt90: '10%',
        lt60_total: 0,
        between60_70_total: 0,
        between70_90_total: 0,
        gt90_total: 0
      },
      rows: [],
      page: 1,
      ipp: 5,
      tableTotals: null,
      detailPopUpTitle: '',
      urlDetailPopUp: '',
      payloadDetails: {},
      detailPopUpVisible: false,
      downloadCsvPopupVisible: false,
    }
  },
  computed: {
    lt60Number () {
      const v = String(this.overviewCounts.lt60 || '0').replace('%','').replace(',','.')
      const n = Number(v)
      return isNaN(n) ? 0 : n
    },

    perfState () {
      if (this.lt60Number >= 20) return 'bad'
      if (this.lt60Number >= 15) return 'moderate'
      return 'good'
    },

    hasData () {
      const conv = Array.isArray(this.reportData?.dados_convertion)
        ? this.reportData.dados_convertion
        : []
      return conv.length > 0
    },
    perfUI () {
      const map = {
        good: {
          title: 'Performance Boa',
          subtitlePrefix: 'Apenas',
          headerBg: 'rgba(66,160,66,0.08)',
          titleColor: '#005229',
          criticalColor: '#7E0007',
          trustColor: '#005229',
          ringBg: '#E9EEF1',
          badge: 'good'
        },
        moderate: {
          title: 'Performance Moderada',
          subtitlePrefix: 'Mais de',
          headerBg: 'rgba(255,84,73,0.04)',
          titleColor: '#BA1A1A',
          criticalColor: '#A30000',
          trustColor: '#004124',
          ringBg: '#FFEFE3',
          badge: 'moderate'
        },
        bad: {
          title: 'Performance Ruim',
          subtitlePrefix: 'Mais de',
          headerBg: 'rgba(255,237,234,1)',
          titleColor: '#7E0007',
          criticalColor: '#7E0007',
          trustColor: '#004124',
          ringBg: '#FFE9E9',
          badge: 'bad'
        }
      }
      return map[this.perfState]
    },

    perfSubtitle () {
      return `${this.perfUI.subtitlePrefix} <strong>${this.overviewCounts.lt60}</strong> das suas matrículas foram previstas com probabilidade menor de 60% nos <strong>últimos 3 meses.</strong.`
    },

    availableIdsByCategory() {
      if (!this.reportData || Object.keys(this.reportData).length === 0) {
        return {};
      }
      return this.originalAvailableIds || calculateAvailableIds(this.reportData);
    },
    tableHeaders () {
      return [
        { title:'Processo', key:'process', align:'start' },
        { title:'Nível de ensino', key:'level' },
        { title:'Unidade', key:'unit' },
        { title:'Modalidade', key:'modality' },
        { title:'Conversões', key:'conversions', align:'end' },
        { title:'Menor de 60%', key:'lt60', align:'end' },
        { title:'Entre 60% e 70%', key:'between60_70', align:'end' },
        { title:'Entre 70% e 90%', key:'between70_90', align:'end' },
        { title:'Maior que 90%', key:'gt90', align:'end' }
      ]
    },
  },
  mounted () {
    this.applyIncomingData(this.data)

    this.initGauge()
  },
  beforeUnmount () {
    if (this.onResize) window.removeEventListener('resize', this.onResize)
    if (this.chart) { this.chart.dispose(); this.chart = null }
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(val) {
        this.reportData = val && typeof val === 'object' ? val : {}
        this.applyIncomingData(this.reportData)

        if (val && !this.originalAvailableIds) {
          const ids = calculateAvailableIds(val);
          if (Object.keys(ids).length > 0) {
            this.originalAvailableIds = ids;
          }
        }
      }
    },
    accuracy () { this.updateGauge() },
    mode(newVal, oldVal) {
      if (newVal === 'chart') {
        this.$nextTick(() => {
          if (!this.chart) this.initGauge();
          else this.chart.resize();
        });
      } else if (oldVal === 'chart') {
        if (this.chart) {
          this.chart.dispose();
          this.chart = null;
        }
      }
    }
  },
  methods: {
    openDownloadCsvPopup() {
      if (!this.rows || !this.rows.length) return
      this.downloadCsvPopupVisible = true
    },
    downloadTableCsv () {
      const fields = this.tableHeaders.map(header => header.title)

      const data = (this.rows || []).map(row =>
        this.tableHeaders.map(header => (row?.[header.key] ?? ''))
      )

      if (this.tableTotals) {
        const totalRow = this.tableHeaders.map(header => {
          if (header.key === 'level') return 'Total geral/Média geral'
          if (header.key === 'unit' || header.key === 'modality') return ''
          return this.tableTotals?.[header.key] ?? ''
        })
        data.push(totalRow)
      }

      const today = new Date().toISOString().slice(0, 10)
      downloadCsv({
        filename: `performance_overview_${today}.csv`,
        fields,
        data,
        delimiter: ';'
      })
    },
    abrirDrawerFiltros () {},

    handleRowClick(item) {
      this.detailPopUpTitle = `${item.level} - ${item.unit} - ${item.modality}`;
      this.urlDetailPopUp = 'insights/getReportForecastByConversion';
      this.payloadDetails = {
        process: item.process_id,
        education_level: item.level_id,
        unit: item.unit_id,
        modality: item.modality_id,
      }
      this.detailPopUpVisible = true;
    },

    fmtPct (n) {
      const num = Number(n) || 0
      return `${num.toFixed(2).replace('.', ',')}%`
    },
    pctToNumber(str){
      if (str == null) return 0
      return Number(String(str).replace('%','').replace(',','.')) || 0
    },
    buildRowsFromConvertion(dadosConv = []) {
      let id = 1
      return dadosConv.map(item => ({
        id: id++,
        process: item.processo || '—',
        level: item.nivel_de_ensino || '—',
        unit: item.unidade || '—',
        modality: item.modalidade || '—',
        process_id: item.idProcesso,
        level_id: item.idNivelDeEnsino,
        unit_id: item.idUnidade,
        modality_id: item.idModalidade,
        conversions: Number(item.matriculas) || 0,
        lt60: this.fmtPct(item.menor_60),
        between60_70: this.fmtPct(item.entre_60_70),
        between70_90: this.fmtPct(
          item.entre_70_90 ?? item.entre_60_90
        ),
        gt90: this.fmtPct(item.maior_90)
      }))
    },

    buildOverviewFromConvertion(dadosConv = []) {
      if (!dadosConv.length) {
        return {
          total: 0,
          lt60: '0,00%',
          between60_70: '0,00%',
          between70_90: '0,00%',
          gt90: '0,00%',
          lt60_total: 0,
          between60_70_total: 0,
          between70_90_total: 0,
          gt90_total: 0
        }
      }

      let totalMatriculas = 0
      let lt60Count = 0
      let between60_70Count = 0
      let between70_90Count = 0
      let gt90Count = 0

      for (const item of dadosConv) {
        const m = Number(item.matriculas) || 0
        const pLt60 = Number(item.menor_60) || 0
        const p60_70 = Number(item.entre_60_70) || 0
        const p70_90 = Number(item.entre_70_90 ?? item.entre_60_90) || 0
        const pGt90 = Number(item.maior_90) || 0

        totalMatriculas += m
        lt60Count        += m * (pLt60  / 100)
        between60_70Count+= m * (p60_70 / 100)
        between70_90Count+= m * (p70_90 / 100)
        gt90Count        += m * (pGt90  / 100)
      }

      const total = totalMatriculas

      return {
        total: totalMatriculas,
        lt60: this.fmtPct((lt60Count / total) * 100),
        between60_70: this.fmtPct((between60_70Count / total) * 100),
        between70_90: this.fmtPct((between70_90Count / total) * 100),
        gt90: this.fmtPct((gt90Count / total) * 100),
        lt60_total: Math.round(lt60Count),
        between60_70_total: Math.round(between60_70Count),
        between70_90_total: Math.round(between70_90Count),
        gt90_total: Math.round(gt90Count)
      }
    },

    buildTableTotalsFromConvertion(dadosConv = []) {
      if (!dadosConv.length) return null

      let totalMatriculas = 0
      let lt60Count = 0
      let between60_70Count = 0
      let between70_90Count = 0
      let gt90Count = 0

      for (const item of dadosConv) {
        const m = Number(item.matriculas) || 0
        const pLt60 = Number(item.menor_60) || 0
        const p60_70 = Number(item.entre_60_70) || 0
        const p70_90 = Number(item.entre_70_90 ?? item.entre_60_90) || 0
        const pGt90 = Number(item.maior_90) || 0

        totalMatriculas += m
        lt60Count        += m * (pLt60  / 100)
        between60_70Count+= m * (p60_70 / 100)
        between70_90Count+= m * (p70_90 / 100)
        gt90Count        += m * (pGt90  / 100)
      }

      const total = totalMatriculas || 1

      return {
        conversions: totalMatriculas,
        lt60: this.fmtPct((lt60Count / total) * 100),
        between60_70: this.fmtPct((between60_70Count / total) * 100),
        between70_90: this.fmtPct((between70_90Count / total) * 100),
        gt90: this.fmtPct((gt90Count / total) * 100)
      }
    },

    applyIncomingData(payload) {
      if (!payload || typeof payload !== 'object') return

      const dadosConv = Array.isArray(payload.dados_convertion)
        ? payload.dados_convertion
        : []

      if (!dadosConv.length) {
        this.rows = []
        this.tableTotals = null
        this.overviewCounts = {
          total: 0,
          lt60: '0,00%',
          between60_70: '0,00%',
          between70_90: '0,00%',
          gt90: '0,00%',
          lt60_total: 0,
          between60_70_total: 0,
          between70_90_total: 0,
          gt90_total: 0
        }
        this.accuracy = 0
        return
      }

      this.overviewCounts = this.buildOverviewFromConvertion(dadosConv)
      const accuracy = 100 - this.pctToNumber(this.overviewCounts.lt60)
      this.accuracy = Number(Math.max(0, Math.min(100, accuracy)).toFixed(2))

      this.rows = this.buildRowsFromConvertion(dadosConv)
      this.tableTotals = this.buildTableTotalsFromConvertion(dadosConv)

      if (this.mode === 'chart') {
        this.$nextTick(() => {
          if (!this.chart) this.initGauge()
          else this.updateGauge()
        })
      }
    },

    gaugeOption (value) {
      const { start, end } = this.gaugePalette
      return {
        title: {
          text: `${this.overviewCounts.total} matrículas`,
          left: 'center',
          top: 254,
          textStyle: {
            fontSize: 16,
            color: '#333'
          }
        },
        series: [{
          type: 'gauge',
          min: 0,
          max: 100,
          startAngle: 90,
          endAngle: -270,
          pointer: { show: false },
          splitLine: { show: false },
          axisTick: { show: false },
          axisLabel: { show: false },
          axisLine: {
            lineStyle: {
              width: 14,
              color: [[1, '#E9EEF1']]
            }
          },
          progress: {
            show: true,
            width: 14,
            roundCap: true,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: start },
                { offset: 1, color: end }
              ])
            }
          },
          data: [{ value }],
          detail: {
            valueAnimation: true,
            offsetCenter: [0, 0],
            fontSize: 22,
            color: '#111',
            formatter: (val) =>
              `${val.toFixed(1).replace('.', ',')}%\nTaxa geral de\nacerto`
          },
          title: { show: false }
        }]
      }
    },

    initGauge () {
      const el = this.$refs.accuracyEl
      if (!el) return

      this.chart = echarts.init(el)
      this.updateGauge()
      this.onResize = () => this.chart && this.chart.resize()
    },

    updateGauge () {
      if (!this.chart) return

      if (this.accuracy < 60) {
        this.gaugePalette = { start: '#7E0007', end: '#C53030' }
      } else if (this.accuracy < 85) {
        this.gaugePalette = { start: '#FF5449', end: '#FFB4AB' }
      } else {
        this.gaugePalette = { start: '#0B3B2E', end: '#00C86E' }
      }

      const option = this.gaugeOption(this.accuracy)

      this.chart.setOption(option, true)
    },

    async loadData(newFilters) {
      this.isLoading = true

      if (newFilters && newFilters !== this.filters) {
        this.filters = newFilters;
      }

      const filtersBody = {
        process: this.filters.processo,
        education_level: this.filters.nivelEnsino,
        modality: this.filters.modalidade,
        search: this.search
      };

      try {
        const newReportData = await PostWithJson('insights/getReportOverview', JSON.stringify(filtersBody))

        this.reportData = newReportData && typeof newReportData === 'object' ? newReportData : {}
        this.applyIncomingData(this.reportData)

      } catch (error) {
        console.error('Erro ao carregar os dados de insights:', error)
        this.reportData = {}
        this.applyIncomingData(this.reportData)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.bg-critical { background: #FFEDEA; }
.bg-trust { background: #EAFFEA; }

.cell { border: 1px solid #C5C7C6; border-bottom: none; border-left: none; }
.cell--left { border-left: none; border-bottom-left-radius: 8px; }
.cell--right { border-right: none; border-bottom-right-radius: 8px; }

.title-card {
  color: var(--Text-Semantic-Success-On-Subtle, #005229);
  font-family: var(--Typescale-Title-Large-Font-family, Roboto);
  font-size: var(--Typescale-Title-Large-Font-size, 22px);
  font-weight: 500;
  line-height: var(--Typescale-Title-Large-Line-height, 31px);
}
.subtitle-card {
  color: var(--Text-Neutral-Primary, #191C1C);
  font-family: var(--Typescale-Body-Large-Font-family, Roboto);
  font-size: var(--Typescale-Body-Large-Font-size, 16px);
  font-style: normal;
  font-weight: 400;
  line-height: var(--Typescale-Body-Large-Line-height, 24px);
  letter-spacing: var(--Typescale-Body-Large-Tracking, 0.5px);
  max-width: 730px;
  align-self: stretch;
}
.title-card-empty {
  color: var(--Text-Semantic-Info-On-Subtle, #354860);
  font-family: var(--Typescale-Title-Large-Font-family, Roboto);
  font-size: var(--Typescale-Title-Large-Font-size, 20px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Typescale-Title-Large-Line-height, 28px);
  letter-spacing: var(--Typescale-Title-Large-Tracking, 0);
}
.text-title-subcard {
  color: var(--Text-Neutral-Primary, #191C1C);
  font-family: var(--Typescale-Title-Medium-Font-family, Roboto);
  font-size: var(--Typescale-Title-Medium-Font-size, 16px);
  font-weight: 500;
  line-height: var(--Typescale-Title-Medium-Line-height, 24px);
}
.insight-percent-text {
  font-family: var(--Typescale-Display-Medium-Font-family, Roboto);
  font-size: var(--Typescale-Display-Medium-Font-size, 45px);
  font-weight: 500;
  line-height: var(--Typescale-Display-Medium-Line-height, 63px);
}

.link-learn-more {
  text-decoration: none;
  color: #005229;
}

@media (max-width: 959.98px) {
  .cell { border-left: none; border-top: 1px solid #C5C7C6; }
  .cell--left { border-top: none; border-bottom-left-radius: 0; }
  .cell--right { border-bottom-right-radius: 0; }
}
</style>
